import { useMemo } from 'react';

import getCheapestFlightOption from '@shared/utils/getCheapestFlightOption';

import { useRoomOptionsData } from '@/v2/components/pages/PackageViewV2/contexts/RoomOptionsContext';
import { CHARGE_KEYS, Charges } from './types';
import { sumChargeAmounts } from './utils';

const useAddDefaultFlightCharges = (offerCharges: Charges | undefined) => {
  const { flightOptions } = useRoomOptionsData() || {};

  const { defaultInbound, defaultOutbound } = useMemo(() => {
    if (!flightOptions?.inbound?.length || !flightOptions?.outbound?.length) {
      return {
        defaultInbound: null,
        defaultOutbound: null,
      };
    }

    const defaultOptions = getCheapestFlightOption(flightOptions);
    return {
      defaultInbound: defaultOptions.cheapestInbound,
      defaultOutbound: defaultOptions.cheapestOutbound,
    };
  }, [flightOptions]);

  return useMemo(() => {
    if (!offerCharges) return null;

    const getSum = sumChargeAmounts(
      offerCharges,
      defaultOutbound?.charges,
      defaultInbound?.charges,
    );

    return CHARGE_KEYS.reduce<Charges>((acc, key) => {
      return {
        ...acc,
        [key]: {
          amount: getSum(key),
          currency: offerCharges?.[key]?.currency,
        },
      };
    }, {} as Charges);
  }, [offerCharges, defaultOutbound?.charges, defaultInbound?.charges]);
};

export default useAddDefaultFlightCharges;
